var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLogin)?_c('div',[_c('web2020Q1WT')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }